import { REMOVE_OWN_KEYS } from './';

export default (resetOwnKeys, pathId, parentKey, parentIndex) => ({
  type: REMOVE_OWN_KEYS,
  payload: { pathId, resetOwnKeys, parentKey, parentIndex },
});
